exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv#sd-cmp div>svg {\n  display: none;\n}\n", ""]);

// exports
